import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Obt_GetUserRestrictionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type Obt_GetUserRestrictionQuery = { __typename?: 'Query', obtGetUserRestriction?: Array<{ __typename?: 'ObtUserRestriction', companyCode?: string | null, departmentCode?: string | null, legalTabName?: string | null }> | null };

export type Obt_UpdateContactDetailsMutationVariables = Types.Exact<{
  contactModel: Types.IObtContactModelInput;
}>;


export type Obt_UpdateContactDetailsMutation = { __typename?: 'Mutation', obtUpdateContactDetail?: { __typename?: 'IObtContactModel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, role?: string | null, mail?: string | null, source?: string | null, valid?: boolean | null, name1?: string | null, name2?: string | null, department?: string | null, phone?: string | null, fax?: string | null, error?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null } | null };

export type Obt_UpdateLegalDetailsMutationVariables = Types.Exact<{
  legalModel: Types.IObtPartnerLegalInput;
}>;


export type Obt_UpdateLegalDetailsMutation = { __typename?: 'Mutation', obtUpdatePartnerLegalDetail?: { __typename?: 'ObtPartnerLegal', localcode?: string | null, codicedest?: string | null, pecaddress?: string | null } | null };

export type Obt_DeletePartnerLegalDetailMutationVariables = Types.Exact<{
  legalModel: Types.IObtPartnerLegalInput;
}>;


export type Obt_DeletePartnerLegalDetailMutation = { __typename?: 'Mutation', obtDeletePartnerLegalDetail?: { __typename?: 'ObtPartnerLegal', localcode?: string | null, codicedest?: string | null, pecaddress?: string | null } | null };

export type Obt_UpdateChannelDetailsMutationVariables = Types.Exact<{
  channelModel: Types.IObtChannelModel;
}>;


export type Obt_UpdateChannelDetailsMutation = { __typename?: 'Mutation', obtUpdateChannelDetail?: { __typename?: 'ObtPartnerChannel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, invprocess?: string | null, validfrom?: string | null, validto?: string | null, status?: string | null, channeltype?: string | null, direction?: string | null, format?: string | null, count?: number | null, provider?: string | null, newProcess?: boolean | null, eskerOnboarded?: boolean | null } | null };

export type Obt_UpdateLietwegsLegalChannelMutationVariables = Types.Exact<{
  idPartner: Types.Scalars['Float']['input'];
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
}>;


export type Obt_UpdateLietwegsLegalChannelMutation = { __typename?: 'Mutation', obtUpdateLietwegsLegalChannel: string };

export type Obt_GetSelectOptionsByNamesQueryQueryVariables = Types.Exact<{
  lang: Types.Scalars['String']['input'];
}>;


export type Obt_GetSelectOptionsByNamesQueryQuery = { __typename?: 'Query', obtGetSearchSelectionOptions?: { __typename?: 'IObtSearchSelectOption', countries?: Array<{ __typename?: 'IObtSelectOption', _id?: string | null, name?: string | null, value?: string | null }> | null, languages?: Array<{ __typename?: 'IObtSelectOption', _id?: string | null, name?: string | null, value?: string | null }> | null, rollouts?: Array<{ __typename?: 'IObtSelectOption', _id?: string | null, name?: string | null, value?: string | null }> | null, companyCodes?: Array<{ __typename?: 'IObtSelectOption', _id?: string | null, name?: string | null, value?: string | null }> | null, systemCodes?: Array<{ __typename?: 'IObtSelectOption', _id?: string | null, name?: string | null, value?: string | null }> | null } | null };

export type Obt_UpdatePartnerCompanyDetailsMutationVariables = Types.Exact<{
  partnerCompany: Types.IObtPartnerCompanyModel;
}>;


export type Obt_UpdatePartnerCompanyDetailsMutation = { __typename?: 'Mutation', obtUpdatePartnerCompanyDetails?: { __typename?: 'ObtPartnerCompany', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, remark?: string | null } | null };

export type GetObtChannelDataQueryVariables = Types.Exact<{
  category: Types.Scalars['String']['input'];
  system: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
}>;


export type GetObtChannelDataQuery = { __typename?: 'Query', obtGetObtChannelData: Array<{ __typename?: 'ObtChannelFormat', category?: string | null, system?: string | null, companyCode?: string | null, invProcess?: Array<string> | null, status?: string | null, direction?: string | null, provider?: string | null, format?: Array<string> | null, channel?: Array<string> | null }> };

export type Obt_PartnerDetailsQueryQueryVariables = Types.Exact<{
  filters: Types.IObtSearchModel;
}>;


export type Obt_PartnerDetailsQueryQuery = { __typename?: 'Query', obtGetPartnerDetails?: { __typename?: 'ObtPartnerDetailResponse', partnerMain?: { __typename?: 'ObtPartnerMain', id?: number | null, partnerno?: string | null, masterpartnerno?: string | null, remark?: string | null, activity?: string | null, blockReason?: string | null, category?: string | null, systemid?: string | null, taxId?: string | null } | null, partnerCompany?: { __typename?: 'ObtPartnerCompany', id?: number | null, partnerno?: string | null, companycode?: string | null, remark?: string | null, cbuno?: string | null, aparpartnerlink?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null } | null, partnerAddress?: { __typename?: 'ObtPartnerAddress', id?: number | null, partnerno?: string | null, partnername?: string | null, street1?: string | null, street2?: string | null, postalcode?: string | null, pobox?: string | null, city?: string | null, region?: string | null, registercourt?: string | null, countrycode?: string | null, phone?: string | null, language?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null } | null, partnerContact?: Array<{ __typename?: 'IObtContactModel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, role?: string | null, mail?: string | null, source?: string | null, valid?: boolean | null, name1?: string | null, name2?: string | null, department?: string | null, phone?: string | null, fax?: string | null, error?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null, status?: string | null }> | null, partnerChannel?: Array<{ __typename?: 'ObtPartnerChannel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, invprocess?: string | null, validfrom?: string | null, validto?: string | null, status?: string | null, channeltype?: string | null, direction?: string | null, format?: string | null, count?: number | null, provider?: string | null, newProcess?: boolean | null, routeId?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null, partnerLegal?: Array<{ __typename?: 'ObtPartnerLegal', id?: number | null, idpartner?: number | null, hstcode?: string | null, localcode?: string | null, codicedest?: string | null, pecaddress?: string | null, leitwegsId?: string | null, leitwegsEmail?: string | null, peppolId?: string | null }> | null, partnerRun?: Array<{ __typename?: 'ObtPartnerRun', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, status?: string | null, startOnboarding?: string | null, estimateOnboardingDate?: string | null, error?: string | null, wave?: string | null }> | null, partnerDoc?: Array<{ __typename?: 'ObtPartnerDoc', id?: number | null, partnerno?: string | null, companycode?: string | null, month?: number | null, year?: number | null, invType?: string | null, channel?: string | null, count?: number | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null, partnerVatcode?: Array<{ __typename?: 'ObtPartnerVatcode', id?: number | null, partnerno?: string | null, country?: string | null, vatcode?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null } | null };

export type Obt_RefreshPartnerContactsQueryVariables = Types.Exact<{
  filters: Types.IObtSearchModel;
}>;


export type Obt_RefreshPartnerContactsQuery = { __typename?: 'Query', obtRefreshPartnerContactDetails?: Array<{ __typename?: 'IObtContactModel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, role?: string | null, mail?: string | null, source?: string | null, valid?: boolean | null, name1?: string | null, name2?: string | null, department?: string | null, phone?: string | null, fax?: string | null, error?: string | null, anlageDatum?: string | null, aenderungDatum?: string | null, anlageUser?: string | null, aenderungUser?: string | null, status?: string | null }> | null };

export type Obt_RefreshPartnerChannelsQueryVariables = Types.Exact<{
  filters: Types.IObtSearchModel;
}>;


export type Obt_RefreshPartnerChannelsQuery = { __typename?: 'Query', obtRefreshPartnerChannelsDetails?: Array<{ __typename?: 'ObtPartnerChannel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, invprocess?: string | null, validfrom?: string | null, validto?: string | null, status?: string | null, channeltype?: string | null, direction?: string | null, format?: string | null, count?: number | null, provider?: string | null, newProcess?: boolean | null, routeId?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null, formatVersion?: string | null }> | null };

export type GetExistingPartnerContactsQueryVariables = Types.Exact<{
  contactsRequest: Types.IObtExistingContactsRequestInput;
}>;


export type GetExistingPartnerContactsQuery = { __typename?: 'Query', obtExistingPartnerContacts?: Array<{ __typename?: 'ObtContactResponse', id_partner?: number | null, partnerno?: string | null, companycode?: string | null, role?: string | null, email?: string | null, department?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null };

export type GetPartnerLegalVatCodeQueryVariables = Types.Exact<{
  partnerno: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
}>;


export type GetPartnerLegalVatCodeQuery = { __typename?: 'Query', obtGetPartnerLegalVatNipInfo?: { __typename?: 'ObtVatNipInfo', id?: number | null, vatcode?: string | null, countrycode?: string | null } | null };

export type GetObtPeppolDataQueryVariables = Types.Exact<{
  country: Types.Scalars['String']['input'];
}>;


export type GetObtPeppolDataQuery = { __typename?: 'Query', obtGetObtPeppolData?: Array<{ __typename?: 'ObtPeppolData', schemeid?: string | null, country?: string | null, icdcode?: string | null, schemename?: string | null, valididlength?: number | null }> | null };


export const Obt_GetUserRestrictionDocument = gql`
    query Obt_getUserRestriction {
  obtGetUserRestriction {
    companyCode
    departmentCode
    legalTabName
  }
}
    `;

/**
 * __useObt_GetUserRestrictionQuery__
 *
 * To run a query within a React component, call `useObt_GetUserRestrictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_GetUserRestrictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_GetUserRestrictionQuery({
 *   variables: {
 *   },
 * });
 */
export function useObt_GetUserRestrictionQuery(baseOptions?: Apollo.QueryHookOptions<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>(Obt_GetUserRestrictionDocument, options);
      }
export function useObt_GetUserRestrictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>(Obt_GetUserRestrictionDocument, options);
        }
// @ts-ignore
export function useObt_GetUserRestrictionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>;
export function useObt_GetUserRestrictionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_GetUserRestrictionQuery | undefined, Obt_GetUserRestrictionQueryVariables>;
export function useObt_GetUserRestrictionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>(Obt_GetUserRestrictionDocument, options);
        }
export type Obt_GetUserRestrictionQueryHookResult = ReturnType<typeof useObt_GetUserRestrictionQuery>;
export type Obt_GetUserRestrictionLazyQueryHookResult = ReturnType<typeof useObt_GetUserRestrictionLazyQuery>;
export type Obt_GetUserRestrictionSuspenseQueryHookResult = ReturnType<typeof useObt_GetUserRestrictionSuspenseQuery>;
export type Obt_GetUserRestrictionQueryResult = Apollo.QueryResult<Obt_GetUserRestrictionQuery, Obt_GetUserRestrictionQueryVariables>;
export const Obt_UpdateContactDetailsDocument = gql`
    mutation Obt_updateContactDetails($contactModel: IObtContactModelInput!) {
  obtUpdateContactDetail(contactModel: $contactModel) {
    id
    partnerno
    idpartner
    companycode
    role
    mail
    source
    valid
    name1
    name2
    department
    phone
    fax
    error
    anlageUser
    anlageDatum
    aenderungUser
    aenderungDatum
  }
}
    `;
export type Obt_UpdateContactDetailsMutationFn = Apollo.MutationFunction<Obt_UpdateContactDetailsMutation, Obt_UpdateContactDetailsMutationVariables>;

/**
 * __useObt_UpdateContactDetailsMutation__
 *
 * To run a mutation, you first call `useObt_UpdateContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_UpdateContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtUpdateContactDetailsMutation, { data, loading, error }] = useObt_UpdateContactDetailsMutation({
 *   variables: {
 *      contactModel: // value for 'contactModel'
 *   },
 * });
 */
export function useObt_UpdateContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Obt_UpdateContactDetailsMutation, Obt_UpdateContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_UpdateContactDetailsMutation, Obt_UpdateContactDetailsMutationVariables>(Obt_UpdateContactDetailsDocument, options);
      }
export type Obt_UpdateContactDetailsMutationHookResult = ReturnType<typeof useObt_UpdateContactDetailsMutation>;
export type Obt_UpdateContactDetailsMutationResult = Apollo.MutationResult<Obt_UpdateContactDetailsMutation>;
export type Obt_UpdateContactDetailsMutationOptions = Apollo.BaseMutationOptions<Obt_UpdateContactDetailsMutation, Obt_UpdateContactDetailsMutationVariables>;
export const Obt_UpdateLegalDetailsDocument = gql`
    mutation Obt_updateLegalDetails($legalModel: IObtPartnerLegalInput!) {
  obtUpdatePartnerLegalDetail(legalModel: $legalModel) {
    localcode
    codicedest
    pecaddress
  }
}
    `;
export type Obt_UpdateLegalDetailsMutationFn = Apollo.MutationFunction<Obt_UpdateLegalDetailsMutation, Obt_UpdateLegalDetailsMutationVariables>;

/**
 * __useObt_UpdateLegalDetailsMutation__
 *
 * To run a mutation, you first call `useObt_UpdateLegalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_UpdateLegalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtUpdateLegalDetailsMutation, { data, loading, error }] = useObt_UpdateLegalDetailsMutation({
 *   variables: {
 *      legalModel: // value for 'legalModel'
 *   },
 * });
 */
export function useObt_UpdateLegalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Obt_UpdateLegalDetailsMutation, Obt_UpdateLegalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_UpdateLegalDetailsMutation, Obt_UpdateLegalDetailsMutationVariables>(Obt_UpdateLegalDetailsDocument, options);
      }
export type Obt_UpdateLegalDetailsMutationHookResult = ReturnType<typeof useObt_UpdateLegalDetailsMutation>;
export type Obt_UpdateLegalDetailsMutationResult = Apollo.MutationResult<Obt_UpdateLegalDetailsMutation>;
export type Obt_UpdateLegalDetailsMutationOptions = Apollo.BaseMutationOptions<Obt_UpdateLegalDetailsMutation, Obt_UpdateLegalDetailsMutationVariables>;
export const Obt_DeletePartnerLegalDetailDocument = gql`
    mutation Obt_deletePartnerLegalDetail($legalModel: IObtPartnerLegalInput!) {
  obtDeletePartnerLegalDetail(legalModel: $legalModel) {
    localcode
    codicedest
    pecaddress
  }
}
    `;
export type Obt_DeletePartnerLegalDetailMutationFn = Apollo.MutationFunction<Obt_DeletePartnerLegalDetailMutation, Obt_DeletePartnerLegalDetailMutationVariables>;

/**
 * __useObt_DeletePartnerLegalDetailMutation__
 *
 * To run a mutation, you first call `useObt_DeletePartnerLegalDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_DeletePartnerLegalDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtDeletePartnerLegalDetailMutation, { data, loading, error }] = useObt_DeletePartnerLegalDetailMutation({
 *   variables: {
 *      legalModel: // value for 'legalModel'
 *   },
 * });
 */
export function useObt_DeletePartnerLegalDetailMutation(baseOptions?: Apollo.MutationHookOptions<Obt_DeletePartnerLegalDetailMutation, Obt_DeletePartnerLegalDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_DeletePartnerLegalDetailMutation, Obt_DeletePartnerLegalDetailMutationVariables>(Obt_DeletePartnerLegalDetailDocument, options);
      }
export type Obt_DeletePartnerLegalDetailMutationHookResult = ReturnType<typeof useObt_DeletePartnerLegalDetailMutation>;
export type Obt_DeletePartnerLegalDetailMutationResult = Apollo.MutationResult<Obt_DeletePartnerLegalDetailMutation>;
export type Obt_DeletePartnerLegalDetailMutationOptions = Apollo.BaseMutationOptions<Obt_DeletePartnerLegalDetailMutation, Obt_DeletePartnerLegalDetailMutationVariables>;
export const Obt_UpdateChannelDetailsDocument = gql`
    mutation Obt_updateChannelDetails($channelModel: IObtChannelModel!) {
  obtUpdateChannelDetail(channelModel: $channelModel) {
    id
    partnerno
    idpartner
    companycode
    invprocess
    validfrom
    validto
    status
    channeltype
    direction
    format
    count
    provider
    newProcess
    eskerOnboarded
  }
}
    `;
export type Obt_UpdateChannelDetailsMutationFn = Apollo.MutationFunction<Obt_UpdateChannelDetailsMutation, Obt_UpdateChannelDetailsMutationVariables>;

/**
 * __useObt_UpdateChannelDetailsMutation__
 *
 * To run a mutation, you first call `useObt_UpdateChannelDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_UpdateChannelDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtUpdateChannelDetailsMutation, { data, loading, error }] = useObt_UpdateChannelDetailsMutation({
 *   variables: {
 *      channelModel: // value for 'channelModel'
 *   },
 * });
 */
export function useObt_UpdateChannelDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Obt_UpdateChannelDetailsMutation, Obt_UpdateChannelDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_UpdateChannelDetailsMutation, Obt_UpdateChannelDetailsMutationVariables>(Obt_UpdateChannelDetailsDocument, options);
      }
export type Obt_UpdateChannelDetailsMutationHookResult = ReturnType<typeof useObt_UpdateChannelDetailsMutation>;
export type Obt_UpdateChannelDetailsMutationResult = Apollo.MutationResult<Obt_UpdateChannelDetailsMutation>;
export type Obt_UpdateChannelDetailsMutationOptions = Apollo.BaseMutationOptions<Obt_UpdateChannelDetailsMutation, Obt_UpdateChannelDetailsMutationVariables>;
export const Obt_UpdateLietwegsLegalChannelDocument = gql`
    mutation Obt_updateLietwegsLegalChannel($idPartner: Float!, $partnerNo: String!, $companyCode: String!) {
  obtUpdateLietwegsLegalChannel(
    idPartner: $idPartner
    partnerNo: $partnerNo
    companyCode: $companyCode
  )
}
    `;
export type Obt_UpdateLietwegsLegalChannelMutationFn = Apollo.MutationFunction<Obt_UpdateLietwegsLegalChannelMutation, Obt_UpdateLietwegsLegalChannelMutationVariables>;

/**
 * __useObt_UpdateLietwegsLegalChannelMutation__
 *
 * To run a mutation, you first call `useObt_UpdateLietwegsLegalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_UpdateLietwegsLegalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtUpdateLietwegsLegalChannelMutation, { data, loading, error }] = useObt_UpdateLietwegsLegalChannelMutation({
 *   variables: {
 *      idPartner: // value for 'idPartner'
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *   },
 * });
 */
export function useObt_UpdateLietwegsLegalChannelMutation(baseOptions?: Apollo.MutationHookOptions<Obt_UpdateLietwegsLegalChannelMutation, Obt_UpdateLietwegsLegalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_UpdateLietwegsLegalChannelMutation, Obt_UpdateLietwegsLegalChannelMutationVariables>(Obt_UpdateLietwegsLegalChannelDocument, options);
      }
export type Obt_UpdateLietwegsLegalChannelMutationHookResult = ReturnType<typeof useObt_UpdateLietwegsLegalChannelMutation>;
export type Obt_UpdateLietwegsLegalChannelMutationResult = Apollo.MutationResult<Obt_UpdateLietwegsLegalChannelMutation>;
export type Obt_UpdateLietwegsLegalChannelMutationOptions = Apollo.BaseMutationOptions<Obt_UpdateLietwegsLegalChannelMutation, Obt_UpdateLietwegsLegalChannelMutationVariables>;
export const Obt_GetSelectOptionsByNamesQueryDocument = gql`
    query Obt_getSelectOptionsByNamesQuery($lang: String!) {
  obtGetSearchSelectionOptions(lang: $lang) {
    countries {
      _id
      name
      value
    }
    languages {
      _id
      name
      value
    }
    rollouts {
      _id
      name
      value
    }
    companyCodes {
      _id
      name
      value
    }
    systemCodes {
      _id
      name
      value
    }
  }
}
    `;

/**
 * __useObt_GetSelectOptionsByNamesQueryQuery__
 *
 * To run a query within a React component, call `useObt_GetSelectOptionsByNamesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_GetSelectOptionsByNamesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_GetSelectOptionsByNamesQueryQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useObt_GetSelectOptionsByNamesQueryQuery(baseOptions: Apollo.QueryHookOptions<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables> & ({ variables: Obt_GetSelectOptionsByNamesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>(Obt_GetSelectOptionsByNamesQueryDocument, options);
      }
export function useObt_GetSelectOptionsByNamesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>(Obt_GetSelectOptionsByNamesQueryDocument, options);
        }
// @ts-ignore
export function useObt_GetSelectOptionsByNamesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>;
export function useObt_GetSelectOptionsByNamesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_GetSelectOptionsByNamesQueryQuery | undefined, Obt_GetSelectOptionsByNamesQueryQueryVariables>;
export function useObt_GetSelectOptionsByNamesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>(Obt_GetSelectOptionsByNamesQueryDocument, options);
        }
export type Obt_GetSelectOptionsByNamesQueryQueryHookResult = ReturnType<typeof useObt_GetSelectOptionsByNamesQueryQuery>;
export type Obt_GetSelectOptionsByNamesQueryLazyQueryHookResult = ReturnType<typeof useObt_GetSelectOptionsByNamesQueryLazyQuery>;
export type Obt_GetSelectOptionsByNamesQuerySuspenseQueryHookResult = ReturnType<typeof useObt_GetSelectOptionsByNamesQuerySuspenseQuery>;
export type Obt_GetSelectOptionsByNamesQueryQueryResult = Apollo.QueryResult<Obt_GetSelectOptionsByNamesQueryQuery, Obt_GetSelectOptionsByNamesQueryQueryVariables>;
export const Obt_UpdatePartnerCompanyDetailsDocument = gql`
    mutation Obt_updatePartnerCompanyDetails($partnerCompany: IObtPartnerCompanyModel!) {
  obtUpdatePartnerCompanyDetails(partnerCompany: $partnerCompany) {
    id
    partnerno
    idpartner
    companycode
    remark
  }
}
    `;
export type Obt_UpdatePartnerCompanyDetailsMutationFn = Apollo.MutationFunction<Obt_UpdatePartnerCompanyDetailsMutation, Obt_UpdatePartnerCompanyDetailsMutationVariables>;

/**
 * __useObt_UpdatePartnerCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useObt_UpdatePartnerCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObt_UpdatePartnerCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtUpdatePartnerCompanyDetailsMutation, { data, loading, error }] = useObt_UpdatePartnerCompanyDetailsMutation({
 *   variables: {
 *      partnerCompany: // value for 'partnerCompany'
 *   },
 * });
 */
export function useObt_UpdatePartnerCompanyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Obt_UpdatePartnerCompanyDetailsMutation, Obt_UpdatePartnerCompanyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Obt_UpdatePartnerCompanyDetailsMutation, Obt_UpdatePartnerCompanyDetailsMutationVariables>(Obt_UpdatePartnerCompanyDetailsDocument, options);
      }
export type Obt_UpdatePartnerCompanyDetailsMutationHookResult = ReturnType<typeof useObt_UpdatePartnerCompanyDetailsMutation>;
export type Obt_UpdatePartnerCompanyDetailsMutationResult = Apollo.MutationResult<Obt_UpdatePartnerCompanyDetailsMutation>;
export type Obt_UpdatePartnerCompanyDetailsMutationOptions = Apollo.BaseMutationOptions<Obt_UpdatePartnerCompanyDetailsMutation, Obt_UpdatePartnerCompanyDetailsMutationVariables>;
export const GetObtChannelDataDocument = gql`
    query getObtChannelData($category: String!, $system: String!, $companyCode: String!) {
  obtGetObtChannelData(
    category: $category
    system: $system
    companyCode: $companyCode
  ) {
    category
    system
    companyCode
    invProcess
    status
    direction
    provider
    format
    channel
  }
}
    `;

/**
 * __useGetObtChannelDataQuery__
 *
 * To run a query within a React component, call `useGetObtChannelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObtChannelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObtChannelDataQuery({
 *   variables: {
 *      category: // value for 'category'
 *      system: // value for 'system'
 *      companyCode: // value for 'companyCode'
 *   },
 * });
 */
export function useGetObtChannelDataQuery(baseOptions: Apollo.QueryHookOptions<GetObtChannelDataQuery, GetObtChannelDataQueryVariables> & ({ variables: GetObtChannelDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>(GetObtChannelDataDocument, options);
      }
export function useGetObtChannelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>(GetObtChannelDataDocument, options);
        }
// @ts-ignore
export function useGetObtChannelDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>;
export function useGetObtChannelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetObtChannelDataQuery | undefined, GetObtChannelDataQueryVariables>;
export function useGetObtChannelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>(GetObtChannelDataDocument, options);
        }
export type GetObtChannelDataQueryHookResult = ReturnType<typeof useGetObtChannelDataQuery>;
export type GetObtChannelDataLazyQueryHookResult = ReturnType<typeof useGetObtChannelDataLazyQuery>;
export type GetObtChannelDataSuspenseQueryHookResult = ReturnType<typeof useGetObtChannelDataSuspenseQuery>;
export type GetObtChannelDataQueryResult = Apollo.QueryResult<GetObtChannelDataQuery, GetObtChannelDataQueryVariables>;
export const Obt_PartnerDetailsQueryDocument = gql`
    query Obt_partnerDetailsQuery($filters: IObtSearchModel!) {
  obtGetPartnerDetails(filters: $filters) {
    partnerMain {
      id
      partnerno
      masterpartnerno
      remark
      activity
      blockReason
      category
      systemid
      taxId
    }
    partnerCompany {
      id
      partnerno
      companycode
      remark
      cbuno
      aparpartnerlink
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
    }
    partnerAddress {
      id
      partnerno
      partnername
      street1
      street2
      postalcode
      pobox
      city
      region
      registercourt
      countrycode
      phone
      language
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
    }
    partnerContact {
      id
      partnerno
      idpartner
      companycode
      role
      mail
      source
      valid
      name1
      name2
      department
      phone
      fax
      error
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
      status
    }
    partnerChannel {
      id
      partnerno
      idpartner
      companycode
      invprocess
      validfrom
      validto
      status
      channeltype
      direction
      format
      count
      provider
      newProcess
      routeId
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
    }
    partnerLegal {
      id
      idpartner
      hstcode
      localcode
      codicedest
      pecaddress
      leitwegsId
      leitwegsEmail
      peppolId
    }
    partnerRun {
      id
      partnerno
      idpartner
      companycode
      status
      startOnboarding
      estimateOnboardingDate
      error
      wave
    }
    partnerDoc {
      id
      partnerno
      companycode
      month
      year
      invType
      channel
      count
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
    }
    partnerVatcode {
      id
      partnerno
      country
      vatcode
      anlageUser
      anlageDatum
      aenderungUser
      aenderungDatum
    }
  }
}
    `;

/**
 * __useObt_PartnerDetailsQueryQuery__
 *
 * To run a query within a React component, call `useObt_PartnerDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_PartnerDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_PartnerDetailsQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useObt_PartnerDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables> & ({ variables: Obt_PartnerDetailsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>(Obt_PartnerDetailsQueryDocument, options);
      }
export function useObt_PartnerDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>(Obt_PartnerDetailsQueryDocument, options);
        }
// @ts-ignore
export function useObt_PartnerDetailsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>;
export function useObt_PartnerDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_PartnerDetailsQueryQuery | undefined, Obt_PartnerDetailsQueryQueryVariables>;
export function useObt_PartnerDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>(Obt_PartnerDetailsQueryDocument, options);
        }
export type Obt_PartnerDetailsQueryQueryHookResult = ReturnType<typeof useObt_PartnerDetailsQueryQuery>;
export type Obt_PartnerDetailsQueryLazyQueryHookResult = ReturnType<typeof useObt_PartnerDetailsQueryLazyQuery>;
export type Obt_PartnerDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useObt_PartnerDetailsQuerySuspenseQuery>;
export type Obt_PartnerDetailsQueryQueryResult = Apollo.QueryResult<Obt_PartnerDetailsQueryQuery, Obt_PartnerDetailsQueryQueryVariables>;
export const Obt_RefreshPartnerContactsDocument = gql`
    query Obt_refreshPartnerContacts($filters: IObtSearchModel!) {
  obtRefreshPartnerContactDetails(filters: $filters) {
    id
    partnerno
    idpartner
    companycode
    role
    mail
    source
    valid
    name1
    name2
    department
    phone
    fax
    error
    anlageDatum
    aenderungDatum
    anlageUser
    aenderungUser
    status
  }
}
    `;

/**
 * __useObt_RefreshPartnerContactsQuery__
 *
 * To run a query within a React component, call `useObt_RefreshPartnerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_RefreshPartnerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_RefreshPartnerContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useObt_RefreshPartnerContactsQuery(baseOptions: Apollo.QueryHookOptions<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables> & ({ variables: Obt_RefreshPartnerContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>(Obt_RefreshPartnerContactsDocument, options);
      }
export function useObt_RefreshPartnerContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>(Obt_RefreshPartnerContactsDocument, options);
        }
// @ts-ignore
export function useObt_RefreshPartnerContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>;
export function useObt_RefreshPartnerContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_RefreshPartnerContactsQuery | undefined, Obt_RefreshPartnerContactsQueryVariables>;
export function useObt_RefreshPartnerContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>(Obt_RefreshPartnerContactsDocument, options);
        }
export type Obt_RefreshPartnerContactsQueryHookResult = ReturnType<typeof useObt_RefreshPartnerContactsQuery>;
export type Obt_RefreshPartnerContactsLazyQueryHookResult = ReturnType<typeof useObt_RefreshPartnerContactsLazyQuery>;
export type Obt_RefreshPartnerContactsSuspenseQueryHookResult = ReturnType<typeof useObt_RefreshPartnerContactsSuspenseQuery>;
export type Obt_RefreshPartnerContactsQueryResult = Apollo.QueryResult<Obt_RefreshPartnerContactsQuery, Obt_RefreshPartnerContactsQueryVariables>;
export const Obt_RefreshPartnerChannelsDocument = gql`
    query Obt_refreshPartnerChannels($filters: IObtSearchModel!) {
  obtRefreshPartnerChannelsDetails(filters: $filters) {
    id
    partnerno
    idpartner
    companycode
    invprocess
    validfrom
    validto
    status
    channeltype
    direction
    format
    count
    provider
    newProcess
    routeId
    anlageUser
    anlageDatum
    aenderungUser
    aenderungDatum
    formatVersion
  }
}
    `;

/**
 * __useObt_RefreshPartnerChannelsQuery__
 *
 * To run a query within a React component, call `useObt_RefreshPartnerChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_RefreshPartnerChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_RefreshPartnerChannelsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useObt_RefreshPartnerChannelsQuery(baseOptions: Apollo.QueryHookOptions<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables> & ({ variables: Obt_RefreshPartnerChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>(Obt_RefreshPartnerChannelsDocument, options);
      }
export function useObt_RefreshPartnerChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>(Obt_RefreshPartnerChannelsDocument, options);
        }
// @ts-ignore
export function useObt_RefreshPartnerChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>;
export function useObt_RefreshPartnerChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_RefreshPartnerChannelsQuery | undefined, Obt_RefreshPartnerChannelsQueryVariables>;
export function useObt_RefreshPartnerChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>(Obt_RefreshPartnerChannelsDocument, options);
        }
export type Obt_RefreshPartnerChannelsQueryHookResult = ReturnType<typeof useObt_RefreshPartnerChannelsQuery>;
export type Obt_RefreshPartnerChannelsLazyQueryHookResult = ReturnType<typeof useObt_RefreshPartnerChannelsLazyQuery>;
export type Obt_RefreshPartnerChannelsSuspenseQueryHookResult = ReturnType<typeof useObt_RefreshPartnerChannelsSuspenseQuery>;
export type Obt_RefreshPartnerChannelsQueryResult = Apollo.QueryResult<Obt_RefreshPartnerChannelsQuery, Obt_RefreshPartnerChannelsQueryVariables>;
export const GetExistingPartnerContactsDocument = gql`
    query getExistingPartnerContacts($contactsRequest: IObtExistingContactsRequestInput!) {
  obtExistingPartnerContacts(contactsRequest: $contactsRequest) {
    id_partner
    partnerno
    companycode
    role
    email
    department
    anlageUser
    anlageDatum
    aenderungUser
    aenderungDatum
  }
}
    `;

/**
 * __useGetExistingPartnerContactsQuery__
 *
 * To run a query within a React component, call `useGetExistingPartnerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingPartnerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingPartnerContactsQuery({
 *   variables: {
 *      contactsRequest: // value for 'contactsRequest'
 *   },
 * });
 */
export function useGetExistingPartnerContactsQuery(baseOptions: Apollo.QueryHookOptions<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables> & ({ variables: GetExistingPartnerContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>(GetExistingPartnerContactsDocument, options);
      }
export function useGetExistingPartnerContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>(GetExistingPartnerContactsDocument, options);
        }
// @ts-ignore
export function useGetExistingPartnerContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>;
export function useGetExistingPartnerContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExistingPartnerContactsQuery | undefined, GetExistingPartnerContactsQueryVariables>;
export function useGetExistingPartnerContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>(GetExistingPartnerContactsDocument, options);
        }
export type GetExistingPartnerContactsQueryHookResult = ReturnType<typeof useGetExistingPartnerContactsQuery>;
export type GetExistingPartnerContactsLazyQueryHookResult = ReturnType<typeof useGetExistingPartnerContactsLazyQuery>;
export type GetExistingPartnerContactsSuspenseQueryHookResult = ReturnType<typeof useGetExistingPartnerContactsSuspenseQuery>;
export type GetExistingPartnerContactsQueryResult = Apollo.QueryResult<GetExistingPartnerContactsQuery, GetExistingPartnerContactsQueryVariables>;
export const GetPartnerLegalVatCodeDocument = gql`
    query getPartnerLegalVatCode($partnerno: String!, $idpartner: Float!) {
  obtGetPartnerLegalVatNipInfo(partnerno: $partnerno, idpartner: $idpartner) {
    id
    vatcode
    countrycode
  }
}
    `;

/**
 * __useGetPartnerLegalVatCodeQuery__
 *
 * To run a query within a React component, call `useGetPartnerLegalVatCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerLegalVatCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerLegalVatCodeQuery({
 *   variables: {
 *      partnerno: // value for 'partnerno'
 *      idpartner: // value for 'idpartner'
 *   },
 * });
 */
export function useGetPartnerLegalVatCodeQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables> & ({ variables: GetPartnerLegalVatCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>(GetPartnerLegalVatCodeDocument, options);
      }
export function useGetPartnerLegalVatCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>(GetPartnerLegalVatCodeDocument, options);
        }
// @ts-ignore
export function useGetPartnerLegalVatCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>;
export function useGetPartnerLegalVatCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerLegalVatCodeQuery | undefined, GetPartnerLegalVatCodeQueryVariables>;
export function useGetPartnerLegalVatCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>(GetPartnerLegalVatCodeDocument, options);
        }
export type GetPartnerLegalVatCodeQueryHookResult = ReturnType<typeof useGetPartnerLegalVatCodeQuery>;
export type GetPartnerLegalVatCodeLazyQueryHookResult = ReturnType<typeof useGetPartnerLegalVatCodeLazyQuery>;
export type GetPartnerLegalVatCodeSuspenseQueryHookResult = ReturnType<typeof useGetPartnerLegalVatCodeSuspenseQuery>;
export type GetPartnerLegalVatCodeQueryResult = Apollo.QueryResult<GetPartnerLegalVatCodeQuery, GetPartnerLegalVatCodeQueryVariables>;
export const GetObtPeppolDataDocument = gql`
    query getObtPeppolData($country: String!) {
  obtGetObtPeppolData(country: $country) {
    schemeid
    country
    icdcode
    schemename
    valididlength
  }
}
    `;

/**
 * __useGetObtPeppolDataQuery__
 *
 * To run a query within a React component, call `useGetObtPeppolDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObtPeppolDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObtPeppolDataQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetObtPeppolDataQuery(baseOptions: Apollo.QueryHookOptions<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables> & ({ variables: GetObtPeppolDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>(GetObtPeppolDataDocument, options);
      }
export function useGetObtPeppolDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>(GetObtPeppolDataDocument, options);
        }
// @ts-ignore
export function useGetObtPeppolDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>;
export function useGetObtPeppolDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetObtPeppolDataQuery | undefined, GetObtPeppolDataQueryVariables>;
export function useGetObtPeppolDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>(GetObtPeppolDataDocument, options);
        }
export type GetObtPeppolDataQueryHookResult = ReturnType<typeof useGetObtPeppolDataQuery>;
export type GetObtPeppolDataLazyQueryHookResult = ReturnType<typeof useGetObtPeppolDataLazyQuery>;
export type GetObtPeppolDataSuspenseQueryHookResult = ReturnType<typeof useGetObtPeppolDataSuspenseQuery>;
export type GetObtPeppolDataQueryResult = Apollo.QueryResult<GetObtPeppolDataQuery, GetObtPeppolDataQueryVariables>;